<div class="tile" [dir]="textDir">
  <div class="row" style="display: flex;justify-content: space-between;">
    <div style="width:97%;display: inherit;">
    <div style="width:440px;">
      <div class="flexStart">
      <p class="tileTitle" style="margin-bottom: 5px;">{{'User Activity Overview' | translate}}</p>
      <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
   </div>
      <ng-container >
    
        <div style="margin-left:50px;" class="padT30">  
         
          <div class="text" *ngIf="data_01.length==0" [ngClass]="data_01.length==0 ? 'padR85':''" [dir]="textDir">{{'No data' | translate}}</div>
          <div class="chartContainer" [ngClass]="data_01.length==0 ? 'chartDisabled':''">          
          <div id="total-donut" class="total-donut" >{{'Chart' | translate}}</div>
        </div>
        </div>
      </ng-container>
      
    </div>
    <div >

     
      <div style="padding-right: 40px;">
      <ng-container *ngFor="let user of data_01_01; let i = index">
        <div class="userCntDetails" style="margin-top: 20px;">
          <div class="header" style="height:30px;">
            <!-- <div style="font-size: 13px;">
              <span style="margin-right:5px;" [style.color]="settings_01?.colors[i]">
                <i class="icon icon-alarm-level5"></i>
              </span>
              {{user?.role}}
            </div> -->
            <div style="margin-right: 0px;margin-left:0px;display: inline;">
              <div style="display: inline; font-size: 18px;"  class="{{'colorData-'+(i+1)}}" ><i class="icon icon-alarm-level5"></i></div> <div class="devices" style="display: inline;" [dir]="textDir">{{user?.role}}</div>
            </div> 
          </div>
        
          <div class="content" style="display: inline-block;">
            <div class="deviceCount" >
              <div class="usersUsage">
                <p class="devicesCnt"  *ngIf="!isNaN(user?.total)">{{user?.total || 0}}</p>   <p class="devices">{{'Logins' | translate}}</p> 
              </div>
              <div class="usersUsage">
                <p class="devicesCnt" *ngIf="!isNaN(user?.Tablet)">{{user?.Tablet || 0}}%</p><p class="devices">{{'Tablets' | translate}}</p>  
              </div>
              <div class="usersUsage">
                <p class="devicesCnt" *ngIf="!isNaN(user?.Laptop)">{{user?.Laptop|| 0}}%</p> <p class="devices">{{'Laptops' | translate}}</p>
              </div>
            </div>
            <hr *ngIf="i < data_01_01.length" class="marT20">
          </div> 
        </div>
      </ng-container>
    </div>
    
     
    </div> 
  </div>
    <div style="width: 20px;margin-top: 2px;text-align: right;">
      <div #dropdown class="dropdown more" data-type="click">
        <button class="btn clickable"><i class="icon icon-more"></i></button>
        <div class="menu">
          <div class="item" tabindex="0" (click)="generateCSV('users-activity')">{{'Export Panel Data(csv)' | translate}}</div>
          <div class="item" tabindex="0">{{'Export Panel Graphic(pdf)' | translate}}</div>
        </div>
      </div>
    </div> 
  
  </div>
</div>

<br>

<div class="tile" [dir]="textDir">
  <div class="row" style="display: flex;justify-content: space-between;">
    <div style="width:97%;display: inherit;">
    <div style="width:29%;height:95%;">
     <div class="flexStart">
       <p class="tileTitle" style="margin-bottom: 5px;">{{'Device Overview' | translate}}</p>
      <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
    </div> 
      <div style="margin: 30px; ">
        <div style="margin: 40px auto;">
          <div style="display: inline-block;">
            <div style="display: inline; margin-right: 10px;"><img src="assets/images/tablet.PNG" width="75px" height="" align="center"/></div> 
            <div style="display: inline;font-size: 26px;" *ngFor="let item of sumofDeviceItems">
              <ng-container *ngIf="item?.id=='Tablet' && !isNaN(item?.deployed); else noTabletData">
                {{item?.deployed}}<span class="devices" >{{'Tablets' | translate}}</span> 
              </ng-container>
            </div>
            <ng-template #noTabletData>
              0 <span class="devices" >{{'Tablets' | translate}}</span> 
            </ng-template>
            <div style="display: inline;font-size: 26px;">
              <ng-container *ngIf="sumofDeviceItems.length==0 ">
               0 <span class="devices" >{{'Tablets' | translate}}</span> 
              </ng-container>
            </div>
          </div>
          <div style="display: inline-block;margin-top: 20px;">
            <div style="display: inline;margin-right: 10px;"><img src="assets/images/desktop.PNG"  width="75px" height=""  align="center"/></div>
            <div style="display: inline;font-size: 26px;" *ngFor="let item of sumofDeviceItems">
              <ng-container *ngIf="item?.id=='Laptop' && !isNaN(item?.deployed);else noLaptopData">
                {{item?.deployed}}<span class="devices" >{{'Laptops' | translate}}</span> 
              </ng-container>
            </div>
            <ng-template #noLaptopData>
              0 <span class="devices" >{{'Laptops' | translate}}</span> 
            </ng-template>
            <div style="display: inline;font-size: 26px;" >
              <ng-container *ngIf="sumofDeviceItems.length==0">
               0<span class="devices" >{{'Laptops' | translate}}</span> 
              </ng-container>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div style="margin: 20px 0px;">
        <div class="header">
          <div class="left">
            <div class="tileTitle" style="margin-left: 10px;">{{'User to Device Average' | translate}}</div>
          </div>
        </div>
        <div class="content center">
          <div>
            <div class="usersUsage">
              <ng-container >
                <p class="devicesCnt"><span *ngIf="userPerDevice  && !isNaN(userPerDevice)">{{userPerDevice}}</span> <span *ngIf="!userPerDevice">0</span></p>   <p class="devices" [ngClass]="textDir=='rtl'?'marR5':''">{{'Unique users per each device' | translate}}</p> 
              </ng-container>
             
            </div>
          </div>  
        </div>
      </div>
    </div>
    <div class="verticalLine"></div>
    <div style="width:30%;height:95%;">
      <div>
        <p class="tileTitle">{{'Tablet Utilisation' | translate}}</p>
       <!--  <ng-container *ngIf="data_02_01?.length">
        <div style="text-align: center; margin-top: 50px;" id="tabUtilChart" [ctlDonutChart]='settings_02_01' [ctlData]='data_02_01' [fontSize]='fontSmall'>
        </div>
        </ng-container> -->
        <div class="text-center padT30">       
          <div class="text" *ngIf="data_02_01.length==0">{{'No data' | translate}}</div>
          <div class="chartContainer" [ngClass]="data_02_01.length==0 ? 'chartDisabled':''">          
            <div id="percentage-donut1" [ngClass]="textDir=='rtl'?'rtl':''">{{'Chart' | translate}}</div>
          </div>
        </div>
        <hr>
       <!--  <div class="content txtCenter" >
          <div class="txtCenter" *ngFor="let item of sumofDeviceItems">
            <ng-container *ngIf="item?.id=='Tablet'">
              <p>
                {{item?.used}}/{{item?.deployed}}  <span class="devices" >Tablets Used</span>
              </p>
            </ng-container>
          </div>
        </div> -->
      </div>
    </div>


    <div class="verticalLine"></div>
    <div style="width:30%;height:95%;">
      <div style="width:100%;display: flex;justify-content: space-between;">
       
        

     
      <div >
        <div ><p class="tileTitle">{{'PC Utilisation' | translate}}</p></div>
       <!--  <ng-container *ngIf="data_02_02?.length">
          <div style="text-align: center;margin-top: 50px;" id="pcUtilChart" [ctlDonutChart]='settings_02_02' [ctlData]='data_02_02'[fontSize]='fontSmall'>
          </div>
        </ng-container> -->
        <div class="text-center padT30">  
          <div class="text" *ngIf="data_02_02.length==0">{{'No data' | translate}}</div>
          <div class="chartContainer" [ngClass]="data_02_02.length==0 ? 'chartDisabled':''">          
            <div id="percentage-donut2" [dir]="textDir" [ngClass]="textDir=='rtl'?'rtl':''">{{'Chart' | translate}}</div>
          </div>
        </div>
        <hr>
      <!--   <div class="content" >
          <div class="txtCenter" *ngFor="let item of sumofDeviceItems">
            <ng-container *ngIf="item?.id=='Laptop'">
              <p>
                {{item?.used}}/{{item?.deployed}}  <span class="devices" >Laptops Used</span>
              </p>
            </ng-container>
          </div>
        </div> -->
      </div>

     
    </div>

  </div>
    </div>

    <div style="width: 20px;margin-top: 2px;font-size: 16px;text-align: center;">
        <div #deviceDropdown class="dropdown more" data-type="click">
          <button class="btn clickable"><i class="icon icon-more"></i></button>
          <div class="menu">
            <div class="item" tabindex="0" (click)="generateCSV('devices-utilization')">{{'Export Panel Data(csv)' | translate}}</div>
            <div class="item" tabindex="0">{{'Export Panel Graphic(pdf)' | translate}}</div>
          </div>
        </div>
      </div> 
  </div>
</div> 

<br>

<div class="tile" [dir]="textDir">
  <div class="row" >
    <div style="width:97%;display: flex;justify-content: flex-start;height:95%;">
    <div style="min-width:370px;max-width:50%;">
      <div class="flexStart">
      <p class="tileTitle" style="margin-bottom: 5px;">{{'App Usage Overview' | translate}}</p>
      <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
</div>
      <!-- <ng-container *ngIf="data_03?.length">
      <div style="text-align: center;margin-top: 50px;" id="applicationOverviewChart" [ctlDonutChart]='settings_03' [ctlData]='data_03' [fontSize]='fontSmall'>
      </div>
      </ng-container> -->
      <div class="text-center padT30">  
     
      <div class="text" *ngIf="data_03.length==0">{{'No data' | translate}}</div>
      <div class="chartContainer" [ngClass]="data_03.length==0 ? 'chartDisabled':''">          
        <div id="absolute-donut" >{{'Chart' | translate}}</div>
      </div>
      </div>
     
    </div>
    <div class="verticalLine"></div>
    <div   style="width:100%;" >
      <div class="text" *ngIf="sumofApplicationItems.length==0">{{'No data' | translate}}</div>
      <div class="chartContainer" [ngClass]="sumofApplicationItems.length==0 ? 'chartDisabled':''">
      <div style=" display: flex;justify-content: space-between;">
       

        <div style="width:100%; margin-top:50px;">

        <div id="appTableHeader" class="content" style=" height:37px;margin:0px 15px;" [dir]="textDir">
          <table class="table" [dir]="textDir">
          <thead style="color: #f2f2f2;">
            <tr style="color: #f2f2f2;opacity: 0.6;">
             
                <th style="width:150px;" [ngClass]="textDir=='rtl'?'':''">{{'Application' | translate}}</th>
                <th class="center">{{'Usage Hours' | translate}}</th>
                <th class="center">{{'Individual Users' | translate}}</th>
              
            </tr>
          </thead>
          </table>
        </div >
        <div id="appTableBody" class="content" style="display: inline-block; height:250px;overflow-y: auto; scrollbar-width: thin;margin: 1px 15px;" [dir]="textDir">
          <table class="table dashed" [dir]="textDir">
           
            <tbody style="background-color: black; font-size:12px;">
              <tr *ngFor="let item of sumofApplicationItems; let i=index" [attr.data-index]="i">
                <ng-container >
                  <td><span style="font-size: 14px;" [ngClass]="textDir=='rtl'?'pull-right marL5':'pull-left marR5'" class="{{'colorData-'+(i+1)}}"><i class="icon icon-alarm-level5" ></i></span><span style="line-height: 20px;">{{item?.id}}</span></td>
                  <td class="center">{{item?.usage_hours}}</td>
                  <td class="center">{{item?.user_count}}</td>
                </ng-container>
             
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      </div>

     </div>
    </div>
    </div>

    <div style="width: 20px;margin-top: 2px;font-size: 16px;text-align: right;margin-left:7px;">
      <div #applicationDropdown class="dropdown more" data-type="click">
        <button class="btn clickable"><i class="icon icon-more"></i></button>
        <div class="menu">
          <div class="item" tabindex="0" (click)="generateCSV('application-overview')">{{'Export Panel Data(csv)' | translate}}</div>
          <div class="item" tabindex="0">{{'Export Panel Graphic(pdf)' | translate}}</div>
        </div>
      </div>
    </div> 
   
    
  </div>
</div>

<br>

<div class="tile" [dir]="textDir">
  <div class="row" style="display: flex;justify-content: space-between;">
    <div style="width:97%;display: inherit;">
    <div  style="min-width:370px;max-width:50%;">
     <div class="flexStart">
       <p class="tileTitle" style="margin-bottom: 5px;">{{'Learning Content Overview' | translate}}</p>
      <p class="timePeriod-txt"><ng-container *ngIf="dataFiltered">({{dataFiltered}})</ng-container></p>
      </div> 
    <!--   <ng-container *ngIf="data_04?.length">
      <div style="text-align: center;margin-top: 50px;" id="learningContentChart" [ctlDonutChart]='settings_04' [ctlData]='data_04' [fontSize]='fontSmall'>
      </div>
      </ng-container> -->
      <div class="text-center padT30">  
        <div class="text" *ngIf="data_04.length==0">{{'No data' | translate}}</div>
        <div class="chartContainer" [ngClass]="data_04.length==0 ? 'chartDisabled':''">          
          <div id="absolute-donut2" >{{'Chart' | translate}}</div>
        </div>
      </div>
     
    </div>
    <div class="verticalLine"></div>
    <div  style="width:100%;">
      <div class="text" *ngIf="sumofContentItems[0].content_count==0">{{'No data' | translate}}</div>
      <div class="chartContainer" [ngClass]="sumofContentItems[0].content_count==0 ? 'chartDisabled':''">
      <div style="width:100%;display: flex;justify-content: space-between;">
       
      <div style="width:100%; margin-top:50px;">

        <div id="contentTableHeader" class="content" style="width:100%; height:37px;margin-top:1px;" [dir]="textDir" [ngClass]="textDir=='rtl'?'marR15':'marL15'">
          <table class="table" [dir]="textDir" >
          <thead style="color: #f2f2f2;">
            <tr style="color: #f2f2f2;opacity: 0.6;">
             
              <th>{{'Item Type' | translate}}</th>
              <th>{{'No. of Items' | translate}}</th>
              <th>{{'User Count' | translate}}</th>
              <th>{{'Launch Count' | translate}}</th>
              <th>{{'Completions' | translate}}</th>
              
            </tr>
          </thead>
          </table>
        </div>
        <div id="contentTableBody" class="content" style="display: inline-block;height:250px;overflow-y: auto;scrollbar-width:thin;margin:1px 15px;" [dir]="textDir">
          <table class="table dashed" [dir]="textDir" >
           
            <tbody style="background-color: black; font-size:12px;">
              <tr *ngFor="let item of sumofContentItems; let i=index" [attr.data-index]="i">
                <ng-container >
                  <td ><div style="display: inline;font-size: 14px;" [ngClass]="textDir=='rtl'?'pull-right marL5':'pull-left marR5'" class="{{'colorData-'+(i+1)}}"><i class="icon icon-alarm-level5"></i></div><div style="display: inline; line-height: 20px;">{{item?.id}}</div></td>
                </ng-container>  
              
                <td class="txtCenter" >{{item?.content_count}}</td>
                <td class="txtCenter" >{{item?.user_count}}</td>
                <td class="txtCenter" >{{item?.launch_count}}</td>
                <td class="txtCenter" >{{item?.complete_count}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      </div>
      </div>
    </div>
  </div>
    <div style="width: 20px;margin-top: 2px;font-size: 16px;text-align: right;">
      <div #contentDropdown class="dropdown more" data-type="click">
        <button class="btn clickable"><i class="icon icon-more"></i></button>
        <div class="menu">
          <div class="item" tabindex="0" (click)="generateCSV('content-overview')">{{'Export Panel Data(csv)' | translate}}</div>
          <div class="item" tabindex="0">{{'Export Panel Graphic(pdf)' | translate}}</div>
        </div>
      </div>
    </div> 
  </div>
</div>
